import { attr } from '@ember-data/model';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';

// If a description hint token is set to this, the hint is a brand so the capitalization should not be altered
export const BRAND = 'brand';
export default EmberDataBaseModel.extend({
  itemName: attr('string'),
  variationName: attr('string'),
  gtin: attr('string'),
  imageUrls: attr('array'),
  categoryHints: attr('array'),
  descriptionHints: attr('array'),
  suggestedPrice: attr(MoneyProto)
});